import React from 'react';
import { Box, CircularProgress, Fab, Tooltip, useTheme } from '@mui/material';
import { green } from '@mui/material/colors';

type SmallFabProps = {
	tooltip?: string;
	loading?: boolean;
	onClick: any; // click action
	content: React.ReactNode;
	loadContent?: React.ReactNode;
	color?: 'success' | 'error' | 'info' | 'warning' | string;
	disabled?: boolean;
};

const SmallFab: React.FC<SmallFabProps> = ({ tooltip, loading, onClick, content, loadContent, color, disabled }) => {
	const theme = useTheme();

	return (
		<Tooltip title={tooltip} PopperProps={{ style: { zIndex: 30000 } }}>
			<Box sx={{ position: 'relative' }}>
				<Fab
					disabled={loading || disabled}
					size='small'
					onClick={onClick}
					sx={{
						transform: 'scale(0.7)',
						color: theme.palette.getContrastText(color ?? theme.palette.primary.main),
						background: color ?? theme.palette.primary.main,
						':hover': {
							transform: 'scale(0.)',
							opacity: '0.8',
							background: color ?? theme.palette.primary.main,
							color: theme.palette.getContrastText(color ?? theme.palette.primary.main),
						},
					}}
					aria-label='save'
					//color={color}
				>
					{loading && loadContent ? loadContent : content}
				</Fab>
				{loading && (
					<CircularProgress
						size={34}
						sx={{
							color: green[500],
							position: 'absolute',
							top: 3,
							left: 3,
							zIndex: 1,
						}}
					/>
				)}
			</Box>
		</Tooltip>
	);
};

export default SmallFab;
